module.exports = __webpack_public_path__ + "media/images/logos/MARA-College-of-Higher-Education-9a60915a0aa701c9e6c14db83c9bf9f1.svg";